// src/pages/SheEarnsGamesHome.jsx
// Mobile-first Pink Dark Theme Hub Page for SheEarns Games

import React, { useState } from 'react';
import SkillQuest from './games/SkillQuest';
import BudgetBloom from './games/BudgetBloom';
import IkigaiPathFinder from './games/IkigaiPathFinder';
import GreenShaktiChallenge from './games/GreenShaktiChallenge';
import GoalSprint from './games/GoalSprint';
import ShaktiWallet from './games/ShaktiWallet';
import ReflectADay from './games/ReflectADay';
import SheEarnsDashboard from './games/SheEarnsDashboard';

// Game categories list
const categories = [
  { id: 1, title: '💎 Shakti SkillQuest', desc: 'Build your skills through short digital quests and earn gems.', component: <SkillQuest /> },
  { id: 2, title: '💰 Budget Bloom', desc: 'Master digital money management with fun budgeting choices.', component: <BudgetBloom /> },
  { id: 3, title: '🌸 Ikigai Path Finder', desc: 'Discover your purpose through interactive story choices.', component: <IkigaiPathFinder /> },
  { id: 4, title: '🌱 Green Shakti Challenge', desc: 'Grow eco-habits and earn Eco Stars with daily actions.', component: <GreenShaktiChallenge /> },
  { id: 5, title: '🎯 Goal Sprint', desc: 'Turn your life goals into a rewarding sprint challenge.', component: <GoalSprint /> },
  { id: 6, title: '🎯 Reflect-A-Day', desc: 'Turn your life goals into a rewarding sprint challenge.', component: <ReflectADay /> },
  { id: 7, title: '👛 Shakti Wallet', desc: 'Collect Shakti Coins and redeem them for rewards.', component: <ShaktiWallet /> },
  { id: 8, title: '📊 SheEarns Dashboard', desc: 'Track your growth, progress, and rewards in one place.', component: <SheEarnsDashboard /> },
];

export default function SheEarnsGamesHome() {
  const [activeGame, setActiveGame] = useState(null);

  // Active Game View
  if (activeGame) {
    return (
      <div className="min-h-screen bg-pink-950 text-pink-50 p-4 sm:p-6 flex flex-col items-center">
        <button
          onClick={() => setActiveGame(null)}
          className="mb-4 bg-pink-700 hover:bg-pink-600 text-white px-4 py-2 rounded-full text-sm shadow-md transition ite"
        >
          ← Back to Games Home
        </button>
        <div className="rounded-2xl bg-pink-900 p-3 sm:p-4 shadow-lg border border-pink-800">
          {activeGame.component}
        </div>
      </div>
    );
  }

  // Home View
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-gray-950 text-pink-50 p-4 sm:p-6">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-xl sm:text-xl font-bold mb-3 text-center">🎮 SAKSHAM Shakti Games</h1>
        <p className="text-pink-200 text-center text-xs lg:text-sm mb-6">
          Play. Learn. Reflect. Grow. — Every game empowers your inner Shakti.
        </p>

        {/* Game Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 place-items-center">
          {categories.map(cat => (
            <div
              key={cat.id}
              className="bg-black backdrop-blur-sm border border-pink-800 rounded-2xl p-4 flex flex-col items-center justify-between shadow-lg hover:shadow-pink-700/40 transition-all"
            >
              <div>
                <h3 className="text-lg font-semibold mb-2 text-pink-100">{cat.title}</h3>
                <p className="text-sm text-pink-300 leading-snug mb-4">{cat.desc}</p>
              </div>

              {cat.component ? (
                <button
                  onClick={() => setActiveGame(cat)}
                  className="w-full bg-pink-600 hover:bg-pink-500 text-white py-2 rounded-full text-sm font-medium transition"
                >
                  ▶ Play Now
                </button>
              ) : (
                <button
                  disabled
                  className="w-full bg-pink-800 text-pink-400 py-2 rounded-full text-sm font-medium cursor-not-allowed"
                >
                  Coming Soon
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
